
$(document).ready( function() {
    
    $(".faq__question").on("click", function() {
        var $item = $(this).closest(".faq__item"),
            $answer = $item.find(".faq__answer");
        
        if ($(this).hasClass("faq__question--active")) {
            $(this).removeClass("faq__question--active")
            $answer.slideUp(400);
        } else {
            $(this).addClass("faq__question--active");
            $answer.stop(true, true)
                .slideDown(400);
        }

        if ($(this).closest('.faq').data('type') == 'accordion') {
            $item.find(".faq__question--active")
                .removeClass('faq__question--active')
                .end()
                .children(".faq__answer")
                .stop(true, true)
                .slideUp()
        }
    });

});